import AbstractPage from './abstract-page';

export default class MultipleChoice extends AbstractPage {
  constructor(props) {
    super(props);
    this.state = {answer: new Set()};
  }

  onCheck(evt, answer) {
    const checked = evt.target.checked;
    const answers = this.state.answer;
    if (checked) {
      answers.add(answer.next);
    } else {
      answers.delete(answer.next);
    }
  }

  render() {
    const question = this.screenData;
    const mainHeader = (this.props.data.title) ? <h2>{this.props.data.title}</h2> : '';
    const subHeader = (this.props.data.description) ? <span>{this.props.data.description}</span> : '';
    const image = (question.imageSrc) ? <div><img src={question.imageSrc} alt="" style="width: 100%" /></div> : '';
    const imageAuthor = (question.imageAuthor) ? <span>{question.imageAuthor}</span> : '';
    const questionTitle = (question.title) ? <h3>{question.title}</h3> : '';
    const questionDescription = (question.description) ? <div dangerouslySetInnerHTML={{__html: question.description}} /> : '';
    const listOptions = question.answers.map((answer, number) => <li><label><input type="checkbox" checked={this.state.answer.has(number)}
      onInput={(evt) => this.onCheck(evt, answer)} />{answer.title}</label></li>);
    return (
      <article>
        {mainHeader}
        {subHeader}
        {image}
        {imageAuthor}
        <form>
          {questionTitle}
          {questionDescription}
          <ul>
            {listOptions}
          </ul>
          <button type="button"
            onClick={() => {
              this.onNext(Array.from(this.state.answer));
              this.state.answer = new Set();
            }}>Ответить</button>
        </form>
      </article>
    );
  }

  static backDataToModel(step) {
    let result = {};
    result.type = (step.type) ? step.type : null;
    result.isMultiple = false;
    result.imageSrc = (step.imageSrc) ? step.imageSrc : null;
    result.imageAuthor = (step.imageAuthor) ? step.imageAuthor : null;
    result.title = (step.title) ? step.title : null;
    result.description = (step.description) ? step.description : null;
    result.answers = [];
    for (let answer of step.answers) {
      let resultAnswer = {};
      resultAnswer.title = (answer.title) ? answer.title : null;
      resultAnswer.next = (answer.next) ? answer.next : null;
      result.answers.push(resultAnswer);
    }
    return result;
  }
}



// WEBPACK FOOTER //
// ./components/page/view/multiple-choice.js